import { Skeleton, Stack } from '@mui/material';

import TagSkeleton from '../../../components/Tag/Skeleton';
import Typography from '../../../components/Typography';
import { Root } from './styles';

export interface CourseWidgetSkeletonProps {
  className?: string;
}

const CourseWidgetSkeleton = ({ className }: CourseWidgetSkeletonProps) => {
  return (
    <Root className={className}>
      <Stack direction="row" alignItems="center" gap={1.25} px={1.25} py={0.5}>
        <Typography flex={1} variant="paragraphBold" component="h6" textTransform="uppercase">
          <Skeleton variant="text" width={200} />
        </Typography>
        <TagSkeleton />
      </Stack>
      <Typography variant="paragraphRegular" noWrap p={1.25}>
        <Skeleton variant="text" />
      </Typography>
      <Typography variant="paragraphRegular" px={1.25} py={0.5}>
        <Skeleton variant="text" width="60%" />
      </Typography>
    </Root>
  );
};

export default CourseWidgetSkeleton;
